import {
    TextField as MUITextField
} from '@mui/material';
import {
    type FC
} from 'react';

import type {
    TextFieldProps
} from './types';

import styles from './styles';

const TextField: FC<TextFieldProps> = (props) => {
    const {
        sx
    } = props;

    return (
        <MUITextField
            {...props}
            sx={[
                ...(Array.isArray(sx) ? sx : [
                    sx
                ]),
                styles.wrapper
            ]}
        />
    );
};

export default TextField;
